export enum BatchStatus {
    IN_PROGRESS = 'in_progress',
    COMPLETED = 'completed',
    PARTIAL_FAILURE = 'partial_failure',
}
